import { render } from "./PublicUserAddressView.vue?vue&type=template&id=53b4f8b4&scoped=true"
import script from "./PublicUserAddressView.vue?vue&type=script&lang=js"
export * from "./PublicUserAddressView.vue?vue&type=script&lang=js"

import "./PublicUserAddressView.vue?vue&type=style&index=0&id=53b4f8b4&lang=less&scoped=true"
import "./PublicUserAddressView.vue?vue&type=style&index=1&id=53b4f8b4&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b4f8b4"]])

export default __exports__